import { type FC } from "react";
import { KeyboardKey } from "@/components/keyboard/KeyboardKey";
import { cn } from "@/components/podkit/lib/cn";
import { type PlainAgentExecution } from "@/queries/agent-queries";
import { agentExecutionLoading } from "@/utils/agent-executions";
import { useAgentExecutionActions } from "@/hooks/use-agent-execution-actions";
import { Button } from "@/components/flexkit/Button";
import useIsMobileViewport from "@/hooks/use-is-mobile-viewport";

export const StopButton: FC<{ agentExecution: PlainAgentExecution }> = ({ agentExecution }) => {
    const { isMobileViewport } = useIsMobileViewport();
    const { handleStopAgentExecution } = useAgentExecutionActions(agentExecution);

    const isLoading = agentExecution && agentExecutionLoading(agentExecution);
    const isButtonDisabled = !agentExecution || !agentExecutionLoading(agentExecution);

    const handleClick = async (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        await handleStopAgentExecution();
    };

    return (
        <Button
            variant="ghost"
            size="xs"
            className={cn("-mr-1 gap-1.5 text-content-secondary", { "text-content-primary": isLoading })}
            disabled={isButtonDisabled}
            onClick={handleClick}
            data-tracking-id="stop-agent-execution-todo-list"
        >
            Stop
            {!isMobileViewport && (
                <KeyboardKey
                    className={cn(
                        "h-4 bg-content-secondary/20 text-sm leading-4 dark:bg-content-secondary/40",
                        isLoading ? "text-content-primary" : "text-content-secondary",
                    )}
                >
                    Esc
                </KeyboardKey>
            )}
        </Button>
    );
};

export const SkipQuestionsButton: FC<{ onClick: () => void }> = ({ onClick }) => {
    const { isMobileViewport } = useIsMobileViewport();

    return (
        <Button
            variant="ghost"
            size="xs"
            className="-mr-1 gap-1.5 text-content-primary"
            onClick={onClick}
            data-tracking-id="skip-questions-bottom-bar"
        >
            Skip Questions
            {!isMobileViewport && (
                <KeyboardKey className="h-4 bg-content-secondary/20 text-sm leading-4 text-content-primary dark:bg-content-secondary/40">
                    Esc
                </KeyboardKey>
            )}
        </Button>
    );
};
